// extracted by mini-css-extract-plugin
export var tosLink = "_77-0";